import { render } from "./ShippingOptions.vue?vue&type=template&id=4ddb0a53&scoped=true&ts=true"
import script from "./ShippingOptions.vue?vue&type=script&lang=ts"
export * from "./ShippingOptions.vue?vue&type=script&lang=ts"

import "./ShippingOptions.vue?vue&type=style&index=0&id=4ddb0a53&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddb0a53"]])

export default __exports__